"use strict";

var widgetsViewServiceRequestControllers = angular.module("controllers.service.widgets.view", []);

widgetsViewServiceRequestControllers.controller("wServiceRequestDetailsCtrl", ['$scope', 'serviceRequestView', 'clockService', 'localStorageService', 'storageKeys', 'authenticationService','$location',
    function ($scope, serviceRequestView, clockService, localStorageService, storageKeys, authenticationService, $location) {

    if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
        $location.path('/service-request-list');
    } else {
        $scope.appDateTimeFormat = localStorageService.get(storageKeys.appDateTimeFormat);
        $scope.appDateFormat = localStorageService.get(storageKeys.appDateFormat);

        $scope.getSRFromResource = function (serviceRequestResource) {
        var serviceRequest = {};
        if (serviceRequestResource.approved !== null) {
            serviceRequest.approved = serviceRequestResource.approved;
        }
        if (serviceRequestResource.approvedBy !== null) {
            serviceRequest.approvedBy = serviceRequestResource.approvedBy;
        }
        if (serviceRequestResource.approvedTime !== null) {
            serviceRequest.approvedTime = clockService.getTimeFromString(serviceRequestResource.approvedTime);
        }
        if (serviceRequestResource.eta !== null) {
            serviceRequest.eta = clockService.getTimeFromString(serviceRequestResource.eta);
        }
        serviceRequest.cancellationReason = serviceRequestResource.cancellationReason;
        serviceRequest.cancelledByUser = serviceRequestResource.cancelledByUser;
        serviceRequest.created = clockService.getTimeFromString(serviceRequestResource.created);
        serviceRequest.createdBy = serviceRequestResource.createdBy;
        serviceRequest.extendedServiceConfirmed = serviceRequestResource.extendedServiceConfirmed;
        serviceRequest.id = serviceRequestResource.id;
        serviceRequest.notificationPhoneNumber = serviceRequestResource.notificationPhoneNumber;
        serviceRequest.notificationType = serviceRequestResource.notificationType;
        serviceRequest.ticketNumber = serviceRequestResource.ticketNumber;
        serviceRequest.status = serviceRequestResource.status;
        return serviceRequest;
    };
    var serviceRequestResource = serviceRequestView.get().serviceRequest;
    $scope.serviceRequest = $scope.getSRFromResource(serviceRequestResource);
    $scope.serviceEvent = {};
    $scope.engineer = {};
    $scope.serviceProvider = {};
    $scope.machine = {};
    $scope.eventType = {};
    $scope.machineCategory = {};
    $scope.station = {};
    $scope.scheduleStep = null;
    $scope.modelPropertyValues = [];

    if (serviceRequestResource.$has("engineer")) {
        serviceRequestResource.$get("engineer").then(function (engineer) {
            $scope.engineer = engineer;
        });
    }

    if (serviceRequestResource.$has("serviceProvider")) {
        serviceRequestResource.$get("serviceProvider").then(function (serviceProvider) {
            $scope.serviceProvider = serviceProvider;
        });
    }

    if (serviceRequestResource.$has("linkedModelPropertyValues")) {
        serviceRequestResource.$get("linkedModelPropertyValues").then(function (resource) {
            resource.$get("modelPropertyValueList").then(function (modelProperties) {
                if (modelProperties != null && modelProperties.length > 0) {
                    for (var i = 0; i < modelProperties.length; i++) {
                        var modelProperty = Object.assign({}, modelProperties[i]);
                        $scope.modelPropertyValues.push(modelProperty);
                    }
                }
            });
        });
    }

    serviceRequestResource.$get("serviceEvent").then(function (serviceEvent) {
        $scope.serviceEvent = serviceEvent;
        serviceEvent.$get("machine").then(function (machine) {
            $scope.machine = machine;
            machine.$get("machineCategory").then(function (machineCategory) {
                $scope.machineCategory = machineCategory;
            });
            machine.$get("station").then(function (station) {
                $scope.station = station;
            });
        });

        if (serviceEvent.$has("eventType")) {
            serviceEvent.$get("eventType").then(function (eventType) {
                $scope.eventType = eventType;
            });
        }
    });

    if(serviceRequestResource.scheduleStep != null) {
        // Retrieve schedule step details coming from servicerequest table - data provided from external PM
        $scope.scheduleStep = serviceRequestResource.scheduleStep;
    } else {
        // Retrieve schedule step details coming from schedulestep table - data provided from Etech
        serviceRequestResource.$get("schedule-step").then(function (scheduleStep) {
            $scope.scheduleStep = scheduleStep;
            if (scheduleStep && $scope.scheduleStep.overrideDue != null) $scope.scheduleStep.originalDue = $scope.scheduleStep.overrideDue;
        });
    }

    $scope.$on("serviceRequest:updated", function () {
        $scope.serviceRequest = $scope.getSRFromResource(serviceRequestView.get().serviceRequest);
        serviceRequestView.get().serviceRequest.$get("serviceEvent").then(function (serviceEvent) {
            if (serviceEvent.$has("eventType")) {
                serviceEvent.$get("eventType").then(function (eventType) {
                    $scope.eventType = eventType;
                });
            }
        });
    });
    }
}]);

widgetsViewServiceRequestControllers.controller("wServiceRequestWarrantyCtrl", ['$scope', 'serviceRequestView', 'localStorageService', 'filterFilter', 'componentService', 'authenticationService', 'appSettings','$location',
    function ($scope, serviceRequestView, localStorageService, filterFilter, componentService, authenticationService, appSettings, $location) {

        if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
            $location.path('/service-request-list');
        } else {
        $scope.costApproverRole=appSettings.costApproverRole;
        $scope.storeApproverRole=appSettings.storeApproverRole;
        $scope.machine = {};
        $scope.underWarranty = false;
        $scope.underComponentWarranty = false;
        $scope.serviceEvent = {};
        $scope.station = {};
        $scope.machineCategory = {};
        $scope.serviceRequest = serviceRequestView.get().serviceRequest;
        $scope.componentsUnderWarranty = [];

        $scope.serviceRequest.$get("serviceEvent").then(function (serviceEvent) {
            $scope.serviceEvent = serviceEvent;
            componentService.partsOnlyWarranty($scope.serviceRequest.id).then(function (result) {
                $scope.partsOnlyWarrantyCover = result.content;
            })
            serviceEvent.$get("machine").then(function (machine) {
                $scope.machine = machine;
                machine.$get("machineCategory").then(function (machineCategory) {
                    $scope.machineCategory = machineCategory;
                });
                machine.$get("station").then(function (station) {
                    $scope.station = station;
                });
                machine.$get("partsWithExtendedWarranty").then(function (partsWithExtendedWarranty) {
                    $scope.underWarranty = $scope.serviceEvent.underWarranty;
                    $scope.underComponentWarranty = partsWithExtendedWarranty.underComponentWarranty;
                    $scope.componentsUnderWarranty = partsWithExtendedWarranty.components;
                });
            });
        });
        $scope.hasRole = function (role) {
            return authenticationService.userHasRole(role);
        }
        }
    }]);

widgetsViewServiceRequestControllers.controller("wServiceRequestVisitsCtrl", ['$scope', 'serviceRequestView', 'clockService', 'authenticationService','$location',
    function ($scope, serviceRequestView, clockService, authenticationService, $location) {

    if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
        $location.path('/service-request-list');
    } else {
    $scope.visits = [];
    $scope.serviceRequest = serviceRequestView.get().serviceRequest;

    $scope.serviceRequest.$get("visits").then(function (resource) {
        resource.$get("visitList").then(function (visits) {

            visits.forEach(function (visitResource) {
                // fetching engineer
                visitResource.$get("engineer").then(function (engineer) {
                    var visit = {};
                    visit.eta = clockService.getTimeFromString(visitResource.eta);
                    visit.signInTime = clockService.getTimeFromString(visitResource.signInTime);
                    visit.signOutTime = clockService.getTimeFromString(visitResource.signOutTime);
                    visit.outcome = visitResource.outcome;
                    visit.subOutcome = visitResource.subOutcome;
                    visit.engineer = visitResource.engineer;
                    visit.firstName = visitResource.firstName;
                    visit.engineer = engineer;
                    visit.lastName = visitResource.lastName;
                    $scope.visits.push(visit);
                });
            });
        });
    });
    }

}]);

widgetsViewServiceRequestControllers.controller("wServiceRequestHistoryCtrl", ['$scope', 'serviceRequestView', 'clockService', 'authenticationService', 'localStorageService', 'storageKeys','$location',
    function ($scope, serviceRequestView, clockService, authenticationService, localStorageService, storageKeys, $location) {

    if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
        $location.path('/service-request-list');
    } else {
    $scope.serviceProviderShortList = [];
    $scope.auditLogs = [];
    $scope.serviceRequest = serviceRequestView.get().serviceRequest;
    $scope.appDateTimeFormat = localStorageService.get(storageKeys.appDateTimeFormat);
    $scope.appDateFormat = localStorageService.get(storageKeys.appDateFormat);

    $scope.hasRole = function (role) {
        return authenticationService.userHasRole(role);
    };

    $scope.serviceRequest.$get("serviceProviderShortList").then(function (resource) {
        resource.$get("providerShortListEntryList").then(function (serviceProviderShortList) {
            serviceProviderShortList.forEach(function (serviceProviderShortListEntry) {
                // fetching service provider
                serviceProviderShortListEntry.$get("serviceProvider").then(function (serviceProvider) {
                    var pse = {};
                    pse.serviceProvider = serviceProvider;
                    pse.id = serviceProviderShortListEntry.id;
                    pse.preference = serviceProviderShortListEntry.preference;
                    pse.providerAssignmentState = serviceProviderShortListEntry.providerAssignmentState;
                    pse.startDate = clockService.getTimeFromString(serviceProviderShortListEntry.startDate);
                    pse.endDate = clockService.getTimeFromString(serviceProviderShortListEntry.endDate);
                    $scope.serviceProviderShortList.push(pse);
                });
            });
        });
    });

    $scope.serviceRequest.$get("auditLogs").then(function (resource) {
        resource.$get("auditLogList").then(function (auditLogs) {
            auditLogs.forEach(function (auditLogResource) {
                var auditLog = {};
                auditLog.description = auditLogResource.description;
                auditLog.detail = auditLogResource.detail;
                auditLog.eventDateTime = clockService.getTimeFromString(auditLogResource.eventDateTime);
                auditLog.id = auditLogResource.id;
                auditLog.logDateTime = clockService.getTimeFromString(auditLogResource.logDateTime);
                auditLog.newState = auditLogResource.newState;
                auditLog.previousState = auditLogResource.previousState;
                auditLog.user = auditLogResource.user;
                $scope.auditLogs.push(auditLog);
            });
        });
    });
    }
}]);

widgetsViewServiceRequestControllers.controller("wServiceRequestCostSummaryCtrl", ['$scope', 'serviceRequestView', '$translate', 'localStorageService', 'filterFilter', 'authenticationService', 'appSettings', 'configuration', '$window', '$log','$location',
    function ($scope, serviceRequestView, $translate, localStorageService, filterFilter, authenticationService, appSettings, configuration, $window, $log, $location) {

        if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
            $location.path('/service-request-list');
        } else {
        var serviceRequest = serviceRequestView.get().serviceRequest;
        $log.info("serviceRequest "+JSON.stringify(serviceRequest));

        $scope.storeApproverRole=appSettings.storeApproverRole;
        $scope.costSummary = {};
        $scope.machineInfo = {
            description: "",
            fault: ""
        };
        $scope.integratedInvoicingIntegrated = configuration.integratedInvoicingIntegrated;

        $scope.serviceRequestCostsDelegated = serviceRequest.costsDelegated;

        serviceRequest.$get("cost-summary").then(function (resource) {
            $scope.costSummary = resource;
        });

        serviceRequest.$get("serviceEvent").then(function (serviceEvent) {
            $scope.machineInfo.fault = serviceEvent.faultDescription;
            serviceEvent.$get("machine").then(function (machine) {
                $scope.machineInfo.description = machine.name;
                machine.$get("station").then(function (station) {
                    $scope.machineInfo.description = station.name + ": " + $scope.machineInfo.description;
                });
            });
        });

        $scope.hasRole = function (role) {
            return authenticationService.userHasRole(role);
        };

        $scope.getColumnSpan = function () {
            if ($scope.hasRole(appSettings.storeApproverRole)) {
                $scope.columnSpan = 5;
            }
            else {
                $scope.columnSpan = 4;
            }
            return $scope.columnSpan;
        }

        $scope.redirectToIntegratedInvoicing = function(){
            $window.open(configuration.integratedInvoicingUri + "/costs/servicerequest/"+serviceRequest.ticketNumber);
        }
        }
    }]);

widgetsViewServiceRequestControllers.controller("wServiceRequestNotesCtrl", ['$scope', 'serviceRequestView', 'clockService', 'authenticationService', 'appSettings','$location',
    function ($scope, serviceRequestView, clockService, authenticationService, appSettings, $location) {
    if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
        $location.path('/service-request-list');
    } else {
    $scope.isEngineer = authenticationService.userHasRole(appSettings.engineerRole);

    $scope.note = {
        text: "",
        privacyStatus: "PUBLIC",
        error: false
    };

    $scope.notes = [];
    $scope.serviceRequest = serviceRequestView.get().serviceRequest;

    $scope.addNote = function () {
        var note = {
            text: $scope.note.text,
            privacyStatus: $scope.note.privacyStatus,
            serviceEvent: {
                id: 0
            }
        };

        $scope.serviceRequest.$get("serviceEvent").then(function (serviceEvent) {
            note.serviceEvent.id = serviceEvent.id;

            serviceRequestView.addNote(note).then(
                function () {
                    loadNotes();
                    $("#note-create").modal("hide");
                    $scope.note = {
                        text: "",
                        error: false
                    };
                }
            );
        });

    }

    loadNotes();
    }

    function loadNotes() {
        $scope.notes = [];
        $scope.serviceRequest.$get("notes").then(function (resource) {
            resource.$get("noteList").then(function (notes) {
                notes.forEach(function (noteResource) {
                    var note = {};
                    note.creationTime = clockService.getTimeFromString(noteResource.creationTime);
                    note.author = noteResource.author;
                    note.text = noteResource.text;
                    $scope.notes.push(note);
                });
            });
        });
    }

    }]);

widgetsViewServiceRequestControllers.controller("wServiceRequestResultsCtrl", ['$scope', 'serviceRequestView', 'authenticationService','$location',
    function ($scope, serviceRequestView, authenticationService, $location) {

    if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
        $location.path('/service-request-list');
    } else {
    $scope.results = [];
    $scope.hasResults = false;

    $scope.serviceRequest = serviceRequestView.get().serviceRequest;

    $scope.serviceRequest.$get("results").then(function (resource) {
        resource.$get("sampleTestResultList").then(function (results) {
            $scope.results = results;
            $scope.hasResults = true;
        });
    });
    }

}]);

var ServiceAgentModalCtrl = ("ServiceAgentModalCtrl", ['$scope', '$modalInstance', 'request', 'authenticationService','$location',
    function ($scope, $modalInstance, request, authenticationService, $location) {

    if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
        $location.path('/service-request-list');
    } else {
    $scope.request = request;
    $scope.close = function () {
        $modalInstance.close('close');
    };
    }
}]);

widgetsViewServiceRequestControllers.controller("wServiceRequestResubmitCtrl",
    ['$scope', '$rootScope', 'wikiService', 'serviceRequestView', 'providerService', 'serviceRequestService', 'authenticationService', '$route', '$modal', '$translate','$location',
        'serviceProviderResponseTimeService', function ($scope, $rootScope, wikiService, serviceRequestView, providerService, serviceRequestService, authenticationService, $route,
                                                        $modal, $translate, serviceProviderResponseTimeService, $location) {

        if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
            $location.path('/service-request-list');
        } else {
        var serviceRequest = serviceRequestView.get().serviceRequest;
        var defaultAgents = [];
        $scope.serviceAgents = [];

        $scope.defaultCosts = [];
        $scope.availability = null;

        $scope.responseTimes = [];
        $scope.serviceAgentsWithNoInsurance = [];
        $scope.serviceRequestToResubmit = null;

        serviceRequest.$get("serviceProviderShortList").then(function (resource) {
            resource.$get("providerShortListEntryList").then(function (serviceProviderShortList) {
                for (var i = 0; i < serviceProviderShortList.length;) {
                    // fetching service provider
                    serviceProviderShortList[i].$get("serviceProvider").then(function (serviceProvider) {
                        if (!serviceProvider.insured) {
                            $scope.serviceAgentsWithNoInsurance.push(serviceProvider);
                            serviceProviderShortList.splice(i, 1);
                        } else {
                            $scope.serviceAgents.push(serviceProvider);
                            defaultAgents.push(serviceProvider);
                        }
                    });
                    i++;
                }
                angular.forEach($scope.serviceAgents, function (serviceAgent) {
                    serviceProviderResponseTimeService.hasResponseTimes(serviceAgent.id).then(function (result) {
                        serviceAgent.hasVariance = result.content;
                    })
                });
            });
        });

        $scope.removeProvider = function (index) {
            if ($scope.serviceAgents.length > 1) $scope.serviceAgents.splice(index, 1);
        };

        $scope.resetList = function () {
            $scope.serviceAgents = defaultAgents.slice();
        };

        $scope.doResubmit = function () {

            $scope.hasConditions = false;
            $scope.hideTnCInfo = false;

            var serviceRequestToResubmit = {
                id: serviceRequest.id,
                extendedServiceConfirmed: false,
                providerShortList: []
            };

            $scope.serviceRequestToResubmit = serviceRequestToResubmit;

            for (var i = 0; i < $scope.serviceAgents.length; i++) {
                var provider = {
                    serviceProvider: {
                        id: $scope.serviceAgents[i].id
                    }
                };
                serviceRequestToResubmit.providerShortList.push(provider);
            }

            $scope.hoursConditions = [];
            var providerConditions = [];
            var loadedConditions = 0;

            for (var i = 0; i < $scope.serviceAgents.length; i++) {
                if ($scope.serviceAgents[i].confirmExtendedService) {
                    providerConditions.push($scope.serviceAgents[i]);
                    break;
                }
            }

            if (providerConditions.length > 0) {
                $scope.hasConditions = true;
                $scope.hideTnCInfo = true;
                for (var i = 0; i < providerConditions.length; i++) {
                    wikiService.getOutOfHoursConditions(providerConditions[i].id).then(function (wikiResponse) {
                        $scope.hoursConditions.push(wikiResponse);
                        loadedConditions++;
                        if (loadedConditions >= providerConditions.length) $scope.step++;
                    });
                }
            } else {
                serviceRequestService.resubmit($scope.serviceRequestToResubmit).then(
                    function (response) {
                        var message = {
                            message: $translate.instant('label.controller.services.viewWidgetsController.SuccessfulResubmit'),
                            type: "success"
                        }
                        $("#modal-viewer").modal("hide");
                        $rootScope.$broadcast("serviceRequest:message", message);
                    }
                );
            }

        };

        $scope.acceptConditions = function () {
            $scope.serviceRequestToResubmit.extendedServiceConfirmed = true;
            serviceRequestService.resubmit($scope.serviceRequestToResubmit).then(
                function (response) {
                    var message = {
                        message: $translate.instant('label.controller.services.viewWidgetsController.SuccessfulResubmit'),
                        type: "success"
                    }
                    $("#modal-viewer").modal("hide");
                    $rootScope.$broadcast("serviceRequest:message", message);
                });
        };

        $scope.rejectConditions = function () {
            $scope.serviceRequestToResubmit.extendedServiceConfirmed = false;
            serviceRequestService.resubmit($scope.serviceRequestToResubmit).then(
                function (response) {
                    var message = {
                        message: $translate.instant('label.controller.services.viewWidgetsController.SuccessfulResubmit'),
                        type: "success"
                    }
                    $("#modal-viewer").modal("hide");
                    $rootScope.$broadcast("serviceRequest:message", message);
                });
        };

        $("#modal-viewer").on("focus", function () {
            $scope.hasConditions = false;
            $scope.hideTnCInfo = false;
        });

        $scope.goBack = function () {
            $scope.hasConditions = false;
            $scope.hideTnCInfo = false;
        };

        $scope.viewServiceProviderInfo = function (index) {
            $scope.defaultCosts = [];
            $scope.availability = null;
            providerService.getDefaultCosts($scope.serviceAgents[index].id).then(function (resource) {
                resource.$get("defaultCostList").then(function (defaultCosts) {
                    $scope.defaultCosts = defaultCosts;
                });
            });

            providerService.availability($scope.serviceAgents[index].id).then(function (resource) {
                $scope.availability = resource;
            });

            $modal.open({
                templateUrl: "js/directives/templates/serviceAgentInfo.tpl.html",
                controller: ServiceAgentModalCtrl,
                resolve: {
                    request: function () {
                        return $scope;
                    }
                }
            });

            $scope.serviceAgents[index].$get("responseTimes").then(function (result) {
                $scope.responseTimes = result;
            })
        };

        $scope.onFilter = function (evt) {
            if (evt.srcElement.id == "removeProvider") {
                $scope.removeProvider(evt.oldIndex);
            } else if (evt.srcElement.id == "viewServiceProviderInfo") {
                $scope.viewServiceProviderInfo(evt.oldIndex);
            }
        }
        }
    }]);

serviceRequestControllers.controller('wServiceRequestDeferCtrl',
    ['$scope', '$rootScope', 'lookUpService', '$translate', 'serviceRequestView', 'serviceRequestService', 'authenticationService','$location',
        function ($scope, $rootScope, lookUpService, $translate, serviceRequestView, serviceRequestService, authenticationService, $location){

        if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
            $location.path('/service-request-list');
        } else {
        $scope.days = [1, 7, 14, 21];
        $scope.deferralReasons = [];
        $scope.reason = 0;
        $scope.selectedDays = 0;

        var serviceRequest = serviceRequestView.get().serviceRequest;

        lookUpService.list("deferralReason").then(function (resource) {
            resource.$get("deferralReasonList").then(function (deferralReasons) {
                $scope.deferralReasons = deferralReasons;
            });
        });

        $scope.selectReason = function (index) {
            $scope.reason = $scope.deferralReasons[index].id
        }

        $scope.back = function (index) {
            $scope.reason = 0
        }

        $scope.selectDays = function (index) {
            $scope.selectedDays = $scope.days[index];
            serviceRequestService.defer(serviceRequest.id, $scope.reason, $scope.selectedDays).then(function (response) {
                var message = {
                    message: $translate.instant('label.controller.services.viewWidgetsController.SuccessfulDefer'),
                    type: "success"
                };

                $("#modal-viewer").modal("hide");
                $rootScope.$broadcast("serviceRequest:message", message);
            });
        }
        }
    }]);

serviceRequestControllers.controller('wServiceRequestCancellationCtrl',
    ['$scope', '$rootScope', 'lookUpService', '$translate', 'serviceRequestView', 'serviceRequestService', 'authenticationService','$location',
        function ($scope, $rootScope, lookUpService, $translate, serviceRequestView, serviceRequestService, authenticationService, $location) {

        if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
            $location.path('/service-request-list');
        } else {
        var serviceRequest = serviceRequestView.get().serviceRequest;
        $scope.cancellationReasons = [];

        $scope.reasonDescription = {
            text: ""
        };

        $scope.isReasonProvided = function() {
            return $scope.reasonDescription.text.length >= 20;
        };

        var reasonIdOnHold = 7;

        lookUpService.list("cancellationReason").then(function (resource) {
            resource.$get("cancellationReasonList").then(function (cancellationReasons) {
                $scope.cancellationReasons = cancellationReasons;
            });
        });

        $scope.chooseReason = function (index) {
            serviceRequestService.cancel(serviceRequest.id, $scope.cancellationReasons[index].id, $scope.cancellationReasons[index].reason).then(function (response) {
                var message = {
                    message: $translate.instant('label.controller.services.viewWidgetsController.SuccessfulCancel'),
                    type: "success"
                };

                $("#modal-viewer").modal("hide");
                $rootScope.$broadcast("serviceRequest:message", message);
            });
        };

        $scope.cancelOnHold = function () {
            serviceRequestService.cancel(serviceRequest.id, reasonIdOnHold, $scope.reasonDescription.text).then(function (response) {
                var message = {
                    message: $translate.instant('label.controller.services.viewWidgetsController.SuccessfulCancel'),
                    type: "success"
                };

                $("#modal-viewer").modal("hide");
                $scope.reasonDescription = {
                    text: ""
                };

                $rootScope.$broadcast("serviceRequest:message", message);
            });
        }
        }
    }]);

serviceRequestControllers.controller('wServiceRequestApproveCtrl',
    ['$scope', '$rootScope', 'lookUpService', 'serviceRequestView', 'serviceRequestService', 'authenticationService', '$translate','$location',
        function ($scope, $rootScope, lookUpService, serviceRequestView, serviceRequestService, authenticationService, $translate, $location) {

        if(!authenticationService.validateCustomStoreContextHeaderByStoreId()) {
            $location.path('/service-request-list');
        } else {
        $scope.displaySetting = 0;
        $scope.eventType = {};
        $scope.plannedMaintenance = false;
        var serviceRequest = serviceRequestView.get().serviceRequest;
        $scope.faultDescription = "";
        $scope.delayOption = false;
        $scope.days = [1, 7, 14, 21];

        serviceRequest.$get("serviceEvent").then(function (serviceEvent) {
            $scope.faultDescription = serviceEvent.faultDescription;
            serviceEvent.$get("eventType").then(function (eventType) {
                $scope.eventType = eventType;
                var eventId = $scope.eventType.id;
                $scope.isPM((parseInt(eventId) === 3 || parseInt(eventId) === 4 || parseInt(eventId) === 7) && serviceRequest.createdBy === "anonymousUser");
            });
        });

        $scope.isPM = function(pmSelected){
            $scope.plannedMaintenance = pmSelected;
            if(pmSelected) {
                $scope.displaySetting = 1;
            }
        };

        $scope.eventTypes = [];
        var chosenEventType = $scope.eventType.id;

        lookUpService.list("eventType").then(function (resource) {
            resource.$get("eventTypeList").then(function (eventType) {
                $scope.eventTypes = eventType;
            });
        });

        $scope.keepCurrentEventType = function () {
            $scope.displaySetting++
        }

        $scope.chooseEventType = function (index) {
            chosenEventType = $scope.eventTypes[index].id;
            $scope.delayOption = (chosenEventType === 3 || chosenEventType === 4 || chosenEventType === 7);
            $scope.displaySetting++;
        }

        $scope.back = function () {
            if($scope.plannedMaintenance && $scope.displaySetting === 1){}
            else {
                $scope.displaySetting--;
            }
        };

        $scope.approveServiceRequest = function () {

            var serviceRequestToApprove = {
                id: serviceRequest.id,
                extendedServiceConfirmed: serviceRequest.extendedServiceConfirmed,
                serviceEvent: {
                    faultDescription: $scope.faultDescription,
                    eventType: {
                        id: chosenEventType
                    }
                }
            };
            serviceRequestService.approveServiceRequest(serviceRequestToApprove).then(function (response) {
                var message = {
                    message: $translate.instant('label.controller.services.viewWidgetsController.SuccessfulApprove'),
                    type: "success"
                }
                $("#modal-viewer").modal("hide");
                $rootScope.$broadcast("serviceRequest:message", message);
            });
        };

        $scope.chooseDelayDays = function () {
            $scope.displaySetting++;
        }

        $scope.approveAndDelayServiceRequest = function (index) {

            var serviceRequestToApprove = {
                id: serviceRequest.id,
                extendedServiceConfirmed: serviceRequest.extendedServiceConfirmed,
                serviceEvent: {
                    faultDescription: $scope.faultDescription,
                    eventType: {
                        id: chosenEventType
                    }
                }
            };
            serviceRequestService.delayServiceRequest(serviceRequestToApprove, $scope.days[index]).then(function (resource) {
                var message = {
                    message: $translate.instant('label.controller.services.viewWidgetsController.SuccessfulApprove'),
                    type: "success"
                }
                $("#modal-viewer").modal("hide");
                $rootScope.$broadcast("serviceRequest:message", message);
            });
        }
        }

    }]);